module.exports = __webpack_public_path__ + "media/images/loading-8b952a79088d554cc74240005435a879e4fd1e48a16f357d7b77f9c0146b2783.gif";